import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("AntiguedadSaldos");


    export const AntiguedadSaldos = cacheResource({
        GenerarReporteAntiguedad: async (parametros: models.FiltroAntiguedadSaldos): Promise<string> => await controller("GenerarReporte", {}, parametros),
        GenerarEdoCuenta: async (parametros: models.FiltroAntiguedadSaldos): Promise<string> => await controller("GenerarReporteEstadoCuenta", {}, parametros),
        GenerarEdoCuentaDetallado: async (parametros: models.FiltroAntiguedadSaldos): Promise<string> => await controller("GenerarReporteEstadoCuentaDetallado", {}, parametros)
    }, {
        }, {
    
        })


// WEBPACK FOOTER //
// ./app/resources/items/antiguedadsaldos.tsx